<template src="./GridRow.html"></template>
<style scoped src="./GridRow.scss" lang="scss"></style>
<script>
import GridRowItem from "./../GridRowItem";
import GridRowExpanded from "./../GridRowExpanded";
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
const _ = require("lodash");
import ScrollHelper from "@/utils/ScrollHelper";
let __scroll = new ScrollHelper();

import { mapGetters } from "vuex";

// TODO:: cierra el de la fila que ya estuviese abierto, oscurece un poco los demás también
export default {
  props: {
    categoria: Object,
    videoscategoria: Array,
    expanded: Boolean
  },
  components: {
    "app-grid-row-item": GridRowItem,
    "app-grid-row-expanded": GridRowExpanded
  },
  data() {
    return {
      // expanded: false,
      expandedItem: {},
      elementsPerView: 6,
      nSlides: 0,
      isLastPage: false
    };
  },
  computed: {
    ...mapGetters(["clientW", "clientH"])
  },
  watch: {
    expanded: function(newValue, oldValue) {
      // console.log("expanded change " + newValue, oldValue);
    }
  },
  methods: {
    onMouseEnter: function() {
      this.$el.classList.add("over");
    },
    onMouseLeave: function() {
      this.$el.classList.remove("over");
    },
    showExpandedInfo(e) {
      //bloquea scroll
      __scroll.lock(true);

      //elimina desplazamiento over
      this.$refs.rowBox.classList.remove(
        "desplazadoX",
        "desplazadoX--first",
        "desplazadoX--last"
      );

      if (!this.expanded) {
        this.expandedItem = e;
      } else {
        this.expandedItem = e;
      }

      //comunica que hay se empieza a desplegar para que Grid controle
      this.$emit("rowExpandedStart", {});
    },
    doExpandInfo(offsetScroll) {
      // if (!this.expanded) {
      //   this.expandedItem = e;
      //   this.$refs.rowDetail.showDetail(e);
      // } else {
      //   this.expandedItem = e;
      // }

      // COMENTO el scroll
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let rect = this.$el.getBoundingClientRect();

      let offsetTitulo =  40 * window.innerWidth / 1920;
      let eComplete = __scroll.scrollTo(rect.top + scrollTop - offsetScroll - offsetTitulo);
      eComplete.addOnce(() => {
        __scroll.lock(false);
      });

      //animacion interior ficha
      this.$refs.rowDetail.showDetail(this.expandedItem);
    },
    showExpandedInfoMobile(e) {

      __scroll.lock(true);

      this.expandedItem = e;

      //apertura mobile
      this.$store.dispatch("activeVideoCinema", {
        activo: true,
        item: this.expandedItem,
        preview: true
      });
    },
    getExpandedHeight() {
      return this.$refs.rowDetail.getExpandedHeight();
    },
    onDetailClosed() {
      this.$emit("rowBtnClosedClicked");
      // this.expanded = false;
      this.expandedItem = {};
    },
    prevSlide() {
      let newIndex = this.st.activeIndex - this.elementsPerView;
      this.st.slideTo(newIndex, 1200);
    },
    nextSlide() {
      let newIndex = this.st.activeIndex + this.elementsPerView;
      this.st.slideTo(newIndex, 1200);
    },
    updateArrowsState() {
      //muestra flecha next ¿?
      if (this.st.activeIndex + this.elementsPerView > this.nSlides - 1) {
        this.$refs.arrowNext.classList.remove("active");
      } else {
        this.$refs.arrowNext.classList.add("active");
      }
      //muestra flecha prev ¿?
      if (this.st.activeIndex > 0) {
        this.$refs.arrowPrev.classList.add("active");
      } else {
        this.$refs.arrowPrev.classList.remove("active");
      }
    },
    onItemGoBigStarted(elemIndex) {
      //comprueba si es es el primer elemento de la fila visible, ultimo o centrar para escalar en consonancia
      //primer elemento"

      //si es la última página
      if (this.isLastPage) {
        let totalSlidesUltimaPagina = this.nSlides % this.elementsPerView;
        //si ES es la última página
        if (
          (elemIndex - totalSlidesUltimaPagina) % this.elementsPerView ==
          this.elementsPerView - 1
        ) {
          //ultimo elemento
          this.$refs.rowBox.classList.add("desplazadoX--last");
        } else if (
          (elemIndex - totalSlidesUltimaPagina) % this.elementsPerView ==
          0
        ) {
          this.$refs.rowBox.classList.add("desplazadoX--first");
        } else {
          this.$refs.rowBox.classList.add("desplazadoX");
        }
      } else {
        //NO es LA ÚLTIMA PÁGINA
        //comprueba si es el primer elemento de la tanda
        if (elemIndex % this.elementsPerView == 0) {
          this.$refs.rowBox.classList.add("desplazadoX--first");
        } else if (
          elemIndex % this.elementsPerView ==
          this.elementsPerView - 1
        ) {
          //ultimo elemento"
          this.$refs.rowBox.classList.add("desplazadoX--last");
        } else {
          this.$refs.rowBox.classList.add("desplazadoX");
        }
      }
    },
    onItemGoSmallStarted() {
      this.$refs.rowBox.classList.remove(
        "desplazadoX",
        "desplazadoX--first",
        "desplazadoX--last"
      );
    }
  },
  mounted: function() {

    // initSwiper(this.$el.querySelector(".swiper-container"));
    this.st = new Swiper(this.$refs.swiperContainer, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 0,
      // slidesOffsetBefore: 60,
      // slidesOffsetAfter: 60,
      slidesOffsetBefore: (60 * window.innerWidth) / 1920,
      slidesOffsetAfter: (60 * window.innerWidth) / 1920,
      simulateTouch: false,
      virtualTranslate: true,
      on: {
        slideChange: this.updateArrowsState,
        init: swiperInstance => {
          this.nSlides = swiperInstance.slides.length;
          setTimeout(this.updateArrowsState, 200);
        },
        // setTransition: (swiperInstance, transition) => {
        // },
        setTranslate: (swiperInstance, translate) => {
          this.$refs.wrapper.style.transform = `translateX(${translate}px)`;
        },
        reachEnd: swiperInstance => {
          this.isLastPage = true;
        },
        reachBeginning: swiperInstance => {}
      }
    });
  }
};
</script>
